import React, { useState, useEffect } from 'react';
import './Navbars.css';
import { Link } from 'react-router-dom';

const Navbars = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
      if (window.innerWidth > 1024) {
        setIsMenuOpen(false);
        document.body.style.overflow = 'auto';
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    document.body.style.overflow = !isMenuOpen ? 'hidden' : 'auto';
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.style.overflow = 'auto';
  };

  const navItems = [
    { path: "/", label: "HOME" },
    {
      label: "ABOUT US",
      dropdown: [
        { path: "/OverView", label: "Overview" },
        { path: "/InfraStructure", label: "Infrastructure" },
        { path: "/Message", label: "Message's" },
        { path: "/Affiliation", label: "Affiliation" },
        { path: "/Vision_Mission", label: "Vision & Mission" }
      ]
    },
    {
      label: "ACADEMICS",
      dropdown: [
        // { path: "/Curriculum", label: "Curriculum" },
        // { path: "/Faculty", label: "Faculty" },
        { path: "/admission", label: "Admission" },
        { path: "/Syllabus", label: "Syllabus Download" }
      ]
    },
    {
      label: "DEPARTMENT",
      dropdown: [
        { path: "/Civil", label: "Civil Engineering" },
        { path: "/Computerlab", label: "Applied Science" },
        { path: "/Electrical", label: "Electrical Engineering" },
        { path: "/Mechanical", label: "Mechanical Engineering" },
        { path: "/Computer", label: "Computer Science Engineering" },
        { path: "/Electronic", label: "Electronics & Communication" }
      ]
    },
    {
      label: "IQAC (NAAC)",
      dropdown: [
        { path: "/Iqac", label: "About IQAC" },
        { path: "/Naac", label: "Executive Summary" },
        { 
          label: "Profile of the College",
          submenu: [
            { path: "/Naac_2", label: "NAAC 2A" },
            { path: "/Naac_2b", label: "NAAC 2B" }
          ]
        },
        { path: "/Report", label: "Activity Report/Form" },
        { path: "/Notice", label: "Notice" }
      ]
    },
    {
      label: "PLACEMENT",
      dropdown: [
        { path: "/Placement", label: "Placement Details" },
        { path: "/placementlist", label: "Placement List" }
      ]
    },
    { path: "/Course", label: "COURSE" },
    { path: "/NEWS", label: "NEWS" },
    { path: "/Notices", label: "NOTICE" },
    { path: "/Gallery", label: "GALLERY" }
  ];

  const renderNavItem = (item, index) => {
    if (item.path) {
      return (
        <li key={index} className="nav-item">
          <Link to={item.path} className="nav-link" onClick={closeMenu}>
            {item.label}
          </Link>
        </li>
      );
    }

    return (
      <li 
        key={index} 
        className={`nav-item dropdown ${isMobile ? 'mobile-dropdown' : ''}`}
        onMouseEnter={() => !isMobile && setActiveDropdown(index)}
        onMouseLeave={() => !isMobile && setActiveDropdown(null)}
      >
        <button 
          className="dropdown-toggle"
          onClick={() => isMobile && setActiveDropdown(activeDropdown === index ? null : index)}
        >
          {item.label}
          <span className="dropdown-arrow">{activeDropdown === index ? '▲' : '▼'}</span>
        </button>
        
        {(activeDropdown === index || !isMobile) && (
          <ul className={`dropdown-menu ${isMobile ? 'mobile' : ''}`}>
            {item.dropdown.map((subItem, subIndex) => (
              <li key={subIndex} className={subItem.submenu ? 'has-submenu' : ''}>
                {subItem.path ? (
                  <Link to={subItem.path} className="dropdown-link" onClick={closeMenu}>
                    {subItem.label}
                  </Link>
                ) : (
                  <>
                    <span className="submenu-label">{subItem.label}</span>
                    <ul className="submenu">
                      {subItem.submenu.map((subSubItem, subSubIndex) => (
                        <li key={subSubIndex}>
                          <Link to={subSubItem.path} className="dropdown-link" onClick={closeMenu}>
                            {subSubItem.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              </li>
            ))}
          </ul>
        )}
      </li>
    );
  };

  return (
    <nav className="main-navigation">
      <button 
        className={`mobile-nav-toggle ${isMenuOpen ? 'active' : ''}`} 
        onClick={toggleMenu}
        aria-label="Toggle navigation menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div className={`nav-overlay ${isMenuOpen ? 'active' : ''}`} onClick={closeMenu} />
      
      <ul className={`nav-list ${isMenuOpen ? 'active' : ''}`}>
        {navItems.map((item, index) => renderNavItem(item, index))}
      </ul>
    </nav>
  );
};

export default Navbars;